export default "__VITE_ASSET__CskeySxu__"